import { MathJaxContent } from "#/components/mathjax";

import textbookSvg from "#/assets/exam-results/textbook.svg";
import type Props from "./types";

const Textbook = ({ questionLecture }: Readonly<Props>) => {
  if (!questionLecture?.length) return null;

  return (
    <div className="bg-[#ebf8ff] m-4 text-sm leading-6 p-4 px-3 rounded-lg">
      <div className="flex items-center mt-6 mr-2">
        <img src={textbookSvg} alt="درسنامه" className="w-9 h-9 mb-3" />
        <span className="font-bold mb-3 mr-2.5 block">درسنامه</span>
      </div>

      <MathJaxContent value={questionLecture} />
    </div>
  );
};
export default Textbook;
